export const currentOTAS = ['booking@balaena.travel', 'expedia@balaena.travel']
